export const FINANCIAL_INFO_DATA_REQUEST = 'FINANCIAL_INFO_DATA_REQUEST';
export const FINANCIAL_INFO_DATA_SUCCESS = 'FINANCIAL_INFO_DATA_SUCCESS';
export const FINANCIAL_INFO_DATA_FAIL = 'FINANCIAL_INFO_DATA_FAIL';
